/**
 * Public runtime configuration for the platform SPA.
 *
 * These are all NON-secret, public identifiers: the Cognito pool/client ids and
 * the HTTP API base URL are baked into every SPA build and are visible to any
 * browser anyway. They are read from Vite env vars when provided (so a build can
 * target a different environment), with the deployed production values as
 * committed defaults.
 */

interface ViteEnv {
  readonly VITE_COGNITO_REGION?: string;
  readonly VITE_COGNITO_USER_POOL_ID?: string;
  readonly VITE_COGNITO_CLIENT_ID?: string;
  readonly VITE_API_URL?: string;
}

const env = import.meta.env as unknown as ViteEnv;

export interface AppConfig {
  readonly cognitoRegion: string;
  readonly userPoolId: string;
  readonly clientId: string;
  readonly apiUrl: string;
}

export const config: AppConfig = {
  cognitoRegion: env.VITE_COGNITO_REGION ?? 'us-east-2',
  userPoolId: env.VITE_COGNITO_USER_POOL_ID ?? 'us-east-2_2VSUWQgm4',
  clientId: env.VITE_COGNITO_CLIENT_ID ?? '3mojrasi74fm33lsvoi6f0crvr',
  apiUrl: env.VITE_API_URL ?? 'https://jekpyolgv9.execute-api.us-east-2.amazonaws.com',
};
